import { InvoiceType } from '@/warehouse/modules/crossdockReceipt/models';
import { current } from '@reduxjs/toolkit';
import { TrackableStatus } from '@/shared/models';
import { addItemToWorkflowTable } from '@/warehouse/helpers';
/** Works for both caches: with *receipted* invoices and with *not receipted* invoices. */
export function updateInvoicesByMessage({ draft, isReceipted, message, endpointName, eventName, }) {
    // No remove in receipted.
    if (isReceipted && message.invoiceReceiptedQuantity + message.invoiceBlockedQuantity === message.invoiceQuantity) {
        const itemIndex = draft.findIndex((item) => item.invoiceId === message.invoiceId);
        if (itemIndex !== -1) {
            // TODO: (later) add error log to backend.
            console.error(`In ${endpointName}() onCacheEntryAdded '${eventName}' event has wrong id: `, message.invoiceId);
            console.log(`Invoice that is going to become receipted should not exist in receipted tab list`);
            console.log('Draft:', current(draft));
            console.log('message ', message);
            return;
        }
        const invoice = {
            invoiceId: message.invoiceId,
            // TODO: add `invoiceNumber`, `invoiceType` and `trackableStatus` to createOrDeleteStickerItemSocketMessage!!!!!!!
            invoiceNumber: message.invoiceNumber,
            // invoiceNumber: 'UNKNOWN',
            // invoiceType:message.invoiceId, //  InvoiceType.Utd1 | InvoiceType.Utd2 | InvoiceType.Return;
            invoiceType: InvoiceType.Utd1,
            invoiceDate: new Date(message.invoiceDate),
            supplierName: message.supplierName,
            amount: message.invoiceAmount,
            quantity: message.invoiceQuantity,
            receiptedQuantity: message.invoiceReceiptedQuantity,
            blockedQuantity: message.invoiceBlockedQuantity,
            // TODO: add `invoiceNumber`, `invoiceType` and `trackableStatus` to createOrDeleteStickerItemSocketMessage!!!!!!!
            trackableStatus: TrackableStatus.None,
        };
        addItemToWorkflowTable(draft, invoice, 'invoiceId');
        return;
    }
    // No remove in non receipted.
    if (!isReceipted) {
        const invoiceIndex = draft.findIndex((invoice) => invoice.invoiceId === message.invoiceId);
        // if (invoiceIndex === -1) return;
        if (invoiceIndex === -1) {
            // This case can happen if UTD had all receipted items (that is why it is not shown in list and
            // `invoiceIndex === -1`), but then one of items was revoked (cancel receipt). Then this UTD should appear in
            // Inbox tab again.
            const invoice = {
                invoiceId: message.invoiceId,
                // TODO: add `invoiceNumber`, `invoiceType` and `trackableStatus` to createOrDeleteStickerItemSocketMessage!!!!!!!
                invoiceNumber: message.invoiceNumber,
                // invoiceNumber: 'UNKNOWN',
                // invoiceType:message.invoiceId, //  InvoiceType.Utd1 | InvoiceType.Utd2 | InvoiceType.Return;
                invoiceType: InvoiceType.Utd1,
                invoiceDate: new Date(message.invoiceDate),
                supplierName: message.supplierName,
                amount: message.invoiceAmount,
                quantity: message.invoiceQuantity,
                receiptedQuantity: message.invoiceReceiptedQuantity,
                blockedQuantity: message.invoiceBlockedQuantity,
                // TODO: add `invoiceNumber`, `invoiceType` and `trackableStatus` to createOrDeleteStickerItemSocketMessage!!!!!!!
                trackableStatus: TrackableStatus.None,
            };
            addItemToWorkflowTable(draft, invoice, 'invoiceId');
        }
        else {
            draft[invoiceIndex].receiptedQuantity = message.invoiceReceiptedQuantity;
            draft[invoiceIndex].blockedQuantity = message.invoiceBlockedQuantity;
        }
    }
}
